export function validateCnpj(cnpj: string): boolean {
    return /^([0-9]{14}|[0-9]{2}\.?[0-9]{3}\.?[0-9]{3}\/?[0-9]{4}\-?[0-9]{2})$/.test(
        cnpj
    );
}
